import { useState } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PAGE_GUIDES from "components/admin/pageGuides";

const storageKey = (page) => `petrealmadmin.guide.${page}`;

function readOpen(page) {
  try {
    return window.localStorage.getItem(storageKey(page)) !== "closed";
  } catch (e) {
    return true;
  }
}

/** Khung "Trang này dùng để làm gì" đầu mỗi trang, nội dung lấy từ pageGuides.js theo khoá trang. */
function PageGuide({ page }) {
  const guide = PAGE_GUIDES[page];
  const [open, setOpen] = useState(() => readOpen(page));
  if (!guide) return null;

  const toggle = () => {
    const next = !open;
    setOpen(next);
    try {
      window.localStorage.setItem(storageKey(page), next ? "open" : "closed");
    } catch (e) {
      // trình duyệt chặn localStorage thì chỉ không nhớ trạng thái
    }
  };

  return (
    <Card sx={{ mb: 3 }}>
      <MDBox
        px={2}
        py={1}
        display="flex"
        alignItems="center"
        gap={1}
        sx={{ cursor: "pointer" }}
        onClick={toggle}
      >
        <Icon color="info">help_outline</Icon>
        <MDTypography variant="button" fontWeight="bold" sx={{ flex: 1 }}>
          Trang này dùng để làm gì?
        </MDTypography>
        <IconButton size="small" aria-label={open ? "Thu gọn" : "Mở rộng"}>
          <Icon>{open ? "expand_less" : "expand_more"}</Icon>
        </IconButton>
      </MDBox>
      <Collapse in={open}>
        <MDBox px={2} pb={2}>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            {guide.intro}
          </MDTypography>
          <MDBox component="ul" m={0} pl={2.5}>
            {guide.items.map(([name, desc]) => (
              <MDBox component="li" key={name} mb={0.5}>
                <MDTypography variant="button" fontWeight="bold">
                  {name}:
                </MDTypography>{" "}
                <MDTypography variant="button" color="text">
                  {desc}
                </MDTypography>
              </MDBox>
            ))}
          </MDBox>
          {guide.note && (
            <MDTypography variant="caption" color="warning" display="block" mt={1}>
              {guide.note}
            </MDTypography>
          )}
        </MDBox>
      </Collapse>
    </Card>
  );
}

PageGuide.propTypes = {
  page: PropTypes.string.isRequired,
};

export default PageGuide;
